// bully ignore[directory-kebab-case: component-directory-required requires this directory to literally equal the PascalCase file stem (StatusPill), and no rule enforces PascalCase .tsx filenames — kebab-casing both dir and file instead trips oxlint's unicorn/filename-case; no shape satisfies all three checks at once. follow-up: revisit if bully's directory-kebab-case gains a component-directory exemption.]
import React from 'react'
import { Chiclet } from 'sutra/components/Chiclet/Chiclet'

export type AgentStatus = 'active' | 'paused'

export type StatusPillProps = {
  status: AgentStatus
}

const STATUS_LABEL: Record<AgentStatus, string> = {
  active: 'Active',
  paused: 'Paused',
}

export const StatusPill: React.FC<StatusPillProps> = ({ status }) => (
  <Chiclet $tone={status === 'active' ? 'emerald' : 'gray'}>
    {STATUS_LABEL[status]}
  </Chiclet>
)
